import { Loading } from "@components";
import { Descriptions, message, Tag, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import dayjs from "dayjs";
import * as API from "@api";

const { Item } = Descriptions;

export default function User({ className, ...props }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.Users.getOne({ id: props?.id })
      .then(async (res) => {
        setData(res?.data);
        setLoading(false);
      })
      .catch(() => {
        message.error("Error while getting data, please try again later", 2);
        setLoading(false);
      });
  }, []);

  if (loading || !data) {
    return <Loading compact />;
  }

  return (
    <div key={props?.id} className={classNames("w-full", className)}>
      <Descriptions
        extra={
          <Link to={`/users/edit/${data?.id}`}>
            <Button icon={<EditOutlined />}>Edit User</Button>
          </Link>
        }
        size="small"
        layout="vertical"
        column={{ xxl: 3, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}
        title="User Info"
        bordered
        colon={false}
      >
        <Item label="Name">{data?.display_name}</Item>
        <Item label="Email">{data?.email}</Item>
        <Item label="Role">
          <Tag color="blue">{data?.role?.toUpperCase() || "N/a"}</Tag>
        </Item>
        <Item label="Status">
          <Tag color={data?.blocked ? "red" : "green"}>
            {data?.blocked ? "Blocked" : "Active"}
          </Tag>
        </Item>
        <Item label="Last Login">
          {dayjs(data?.updated_at).format("HH:mm · DD MMM YYYY")}
        </Item>
        <Item label="Last Login IP">{data?.last_login_ip}</Item>
      </Descriptions>
    </div>
  );
}
